import React from "react";
import { Send } from "lucide-react";
import api from "../../../lib/api";
import { toast } from "sonner";

export function NewsletterTab({ ctx }) {
  const { products, subs } = ctx;
  return (
      <div>
        <h1 className="serif text-3xl mb-3">Newsletter · {subs.filter((s) => !s.unsubscribed).length}</h1>
        <p className="text-xs text-[#8A857D] mb-6">Subscribers are only emailed when you press the button below — adding stock never emails anyone. · ما يوصل أي إيميل للمشتركين إلا إذا ضغطت الزر تحت. إضافة مخزون ما ترسل لأحد.</p>
        <div className="flex flex-wrap gap-2 mb-8">
          {products.map((p) => (
            <button key={p.id} data-testid={`notify-subs-${p.slug}`} onClick={async () => {
              if (!window.confirm(`Send "${p.name_en} is now available" email to all subscribers?`)) return;
              try { const { data } = await api.post(`/admin/products/${p.id}/notify`); toast.success(`Sending to ${data.recipients} subscribers`); }
              catch { toast.error("Failed to send"); }
            }} className="inline-flex items-center gap-2 border border-[#262421] px-4 py-2 text-xs uppercase tracking-widest hover:border-[#C49A6C]">
              <Send size={13} /> Notify · {p.name_en}
            </button>
          ))}
        </div>
        {subs.length === 0 ? <p className="text-[#8A857D]">No subscribers yet.</p> : (
          <div className="border border-[#262421] divide-y divide-[#262421]">
            {subs.map((s, i) => (
              <div key={s.email} className="flex justify-between p-3 text-sm">
                <span className={s.unsubscribed ? "line-through text-[#6E685F]" : ""}>{s.email} <span className="text-[#6E685F] text-xs">{s.lang?.toUpperCase()}{s.products?.length ? ` · waiting: ${s.products.join(", ")}` : ""}</span></span>
                <span className="text-[#6E685F] text-xs">{s.created_at ? new Date(s.created_at).toLocaleDateString() : ""}</span>
              </div>
            ))}
          </div>
        )}
      </div>
  );
}
